import React from 'react';
import Container from 'react-bootstrap/esm/Container';
import { ChannelTable } from '../Component/Channel/ChannelTable';
export const ChannelPage = () => {
  return (
    <Container style={{ marginTop: '60px' }}>
      <ChannelTable />
    </Container>
  );
};
